<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    :show-close="false"
    center
    width="37%"
  >
    <dialog-header
      slot="title"
      :title="!isEdit?$t('baseData.terminalmanage.terminalInfo.createAndUpdate.create'):$t('baseData.terminalmanage.terminalInfo.createAndUpdate.update')"
      :icon="!isEdit? 'icon-dialog-add':'icon-dialog-update'"
      @close="closeDialog"
    />
    <vue-linetitle>
    <el-row :gutter="10" type="flex" justify="center">
      <el-col :span="24">
        <el-form
          ref="formCenter"
          :rules="rulesCenter"
          :model="formInfo"
          :label-position="'right'"
          :label-width="$t('baseData.terminalmanage.terminalInfo.createAndUpdate.labelWidth')"
        >
          <el-form-item :label="$t('baseData.terminalmanage.terminalInfo.terminalNumber') + '：'" prop="terminalCode">
            <el-input v-model="formInfo.terminalCode" :disabled="isEdit" clearable :placeholder="$t('baseData.terminalmanage.terminalInfo.terminalNumber')" />
          </el-form-item>
          <el-form-item   :label="$t('public.obdCode') + '：'" prop="barcode">
            <el-input :disabled="isEdit" v-model="formInfo.barcode" :maxlength="30" clearable :placeholder="$t('public.obdCode')" />
          </el-form-item>  
          <el-form-item :label="$t('public.sim') + '：'" prop="sim">
            <el-input v-model="formInfo.sim" clearable :placeholder="$t('public.sim')" />
          </el-form-item> 
          <el-form-item :label="$t('public.expirationTime') + '：'" >
            <el-date-picker
              v-model="formInfo.expireTime"
              filterable
              clearable
              :placeholder="$t('public.expirationTime')"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              prefix-icon="el-icon-date"
              :picker-options="datePickerOptions"
            />
          </el-form-item>   

          <el-form-item v-if="isdrivingBoard" :label="$t('public.driveSmallPlate') + '：'" >
            <el-radio-group v-model="formInfo.drivingBoard">
              <el-radio :label="0">
                  {{ $t('public.close') }}
                </el-radio>
                <el-radio :label="1">
                  {{ $t('public.opens') }}
                </el-radio>
                
              </el-radio-group>
          </el-form-item> 

          <el-form-item :label="$t('public.note')+'：'">
            <el-input
              v-model="formInfo.note"
              :rows="6"
              :autosize="{ minRows: 3, maxRows: 3}"
              resize="none"
              :placeholder="$t('public.note')"
              type="textarea"
            />
          </el-form-item>

          <span v-if="isdrivingBoard" style="color: red">
            {{ $t('public.obdNote') }}
          </span>
        </el-form>
      </el-col>
    </el-row>
    </vue-linetitle>
    <!-- <select-sim-dialog
      :visibles.sync="selectSimVisibles"
      @dblclick-select-sim="selectSim"
    /> -->
    <span slot="footer" class="dialog-footer">
      <el-button v-waves class="dialog-cancel" type="primary" @click="handleCancel">{{ $t('public.cancel') }}</el-button>
      <el-button v-waves type="primary" @click="handleSubmit">{{ $t('public.define') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
// request
import { createTerminalCode, updateTerminalCode } from '@/api/obdDevice/manage'
//
// import selectSimDialog from './selectSimDialog'
import reg from '@/utils/reg'
const barCodeReg = /^(?:V2A[a-zA-Z0-9]{5,7}|TL[a-zA-Z0-9]{6})$/

const drivingBoardReg = /^(V2A2)/

export default {
  name: 'AddUpdateDialog',
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const validateterminalcode = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t('baseData.terminalmanage.terminalInfo.createAndUpdate.error.noTerminal')))
      }      
      if (!reg.terminalcode.test(value)) {
        // '
        return cb(new Error(this.$t('baseData.terminalmanage.terminalInfo.createAndUpdate.error.terminalType')))
      }
    }
    const validatebarcode = (rule, value, cb) => {
      if (!value) {
        return cb(new Error(this.$t('baseData.terminalmanage.terminalInfo.createAndUpdate.error.noTerminalBarcode')))
      }
      if(!barCodeReg.test(value)) {
        return cb(new Error(this.$t('baseData.terminalmanage.terminalInfo.createAndUpdate.error.terminalBarcodeType')))
      }
     
    }
    const expireTimebarcode = (rule, value, cb) => {
      if (!value) return cb(new Error(this.$t('baseData.terminalmanage.terminalInfo.createAndUpdate.error.noExpritTime')))
    }
    return {
      rulesCenter: {
        terminalCode: [
          { required: true, trigger: ['blur','change'], validator: validateterminalcode }
        ],
        barcode: [
          { required: true, trigger: ['blur','change'], validator: validatebarcode }
        ],
        expireTime: [
          { required: true, trigger: ['blur','change'], validator: expireTimebarcode }
        ]
      },
      formInfo: {  },
      defaultInfo: { drivingBoard: 0 },
      datePickerOptions: {
        disabledDate (date) {
          return date < new Date()
        }
      }
    }
  },
  watch: {
    visibles(e1) {
      if (e1) {
        this.formInfo = { ...this.defaultInfo,...this.data }
      }
    }
  },
  computed: {
    isdrivingBoard() {
      return drivingBoardReg.test(this.formInfo.barcode)
    } 
    
  },
  methods: {
    // 关闭
    closeDialog() {
      this.$emit('update:visibles', false)
    },
    // 取消
    handleCancel() {
      this.closeDialog()
    },
    // 提交
    handleSubmit() {
      const formList = this.isEdit ? ['terminalCode'] : ['terminalCode', 'barcode']
      const formCheck = this.checkForm({
        formName: 'formCenter',
        formList
      })
      if (!formCheck) {
        return
      }
      const { terminalId, terminalCode, expireTime, barcode, sim, note, drivingBoard } = this.formInfo
      const postData = {
        expireTime,
        terminalCode,
        barcode, 
        sim,
        note
      }
      if(this.isdrivingBoard) {
        postData.drivingBoard = drivingBoard
      }
      for (const k in postData) {
        if (postData[k] === undefined) {
          postData[k] = ''
        }
      }
      if (!this.isEdit) {
        this._createTerminalCode(postData)
      } else {       
        postData.terminalId = terminalId
        this._updateTerminalCode(postData)
      }
    },
    // 新增
    _createTerminalCode(postData) {
      createTerminalCode(postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t('public.createSuccess'),
            duration: 2 * 1000
          })
          this.$emit('add-complete')
          this.closeDialog()
        }
      })
    },
    _updateTerminalCode(postData) {
      updateTerminalCode(postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message:  this.$t('public.updateSuccess'),
            duration: 2 * 1000
          })
          this.$emit('update-complete')
          this.closeDialog()
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
